<template>
	<div class="py-4 container-fluid">
    <div class="row">
        <div class="col-md-12">
			<div class="card" v-if="isLoading">
				<Loading/>
			</div>
            <div class="card" v-if="!isLoading">
                <div class="card-header pb-0">
                    <div class="d-flex align-items-center">
                        <p class="mb-0">Usuario {{ user.AccountId }}</p>
                    </div>
                </div>
                <div class="card-body">
                    <!-- <p class="text-uppercase text-sm">	Detalles</p> -->
                    <div class="row">
                        <div class="col-md-6">
                        <label for="example-text-input" class="form-control-label"
                            >Usuario</label
                        >
                        <argon-input type="text" v-model="user.Name" disabled="true" />
                        </div>
                        <div class="col-md-6">
                        <label for="example-text-input" class="form-control-label"
                            >Correo</label
                        >
                        <argon-input type="text" v-model="user.Email" disabled="true" />
                        </div>
                        <div class="col-md-6">
                        <label for="example-text-input" class="form-control-label"
                            >País</label
                        >
                        <argon-input type="text" v-model="user.PaisContacto__c" disabled="true" />
                        </div>
                        <div class="col-md-6">
                        <label for="example-text-input" class="form-control-label"
                            >Compañia</label
                        >
                        <argon-input type="text" v-model="user.Cadenas__c" disabled="true" />
                        </div>
                        <div class="col-md-6">
                        <label for="example-text-input" class="form-control-label"
                            >Tipo</label
                        >
                        <argon-input type="text" v-model="user.Type" disabled="true" />
                        </div>
                        <div class="col-md-6">
                        <label for="example-text-input" class="form-control-label"
                            >Estado</label
                        >
                        <argon-input type="text" v-model="user.Estado__c" disabled="true" />
                        </div>
                        <div class="col-md-6">
                         <a class="btn btn-danger" @click="toggleUser" v-if="user.Estado__c!='Activo'">Activar Usuario</a>
                         <a class="btn btn-danger" @click="toggleUser" v-if="user.Estado__c=='Activo'">Suspender Usuario</a>
                         
                        </div>
                        <div class="col-md-6">
                          <a class="btn btn-dark" @click="sendCrendentials" v-if="user.Estado__c=='Activo'">Enviar Credenciales</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    import Loading from '../../examples/Loading.vue';
    import ArgonInput from "@/components/ArgonInput.vue";
    import folder from "@/assets/img/folder.png";
    import axios from 'axios';
  export default {
    name: "tables",
    components: {
      Loading,
			ArgonInput,
    },
    data() {
      return {
        folder,
        user:{
          AccountId:null,
          Name:null,
          Email:null,
          Cadenas__c:null,
          PaisContacto__c:null,
          Estado__c:null,
          Type:null
		    },
        isLoading:false,
      };
    },
    methods:{
      async fetchUser(){
        this.isLoading=true;
	      let idUser = this.$route.params.id;
        fetch(this.$EndPoint+'users/edit-user/'+idUser)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.user=result;
          this.isLoading=false;
        })
      },

      toggleUser(){
        let cEstado='Activo';
        if(this.user.Estado__c=='Activo'){
          cEstado='Inactivo';
        }else{
          cEstado='Activo';
        }

        axios.post(this.$EndPoint+'users/update-user/'+this.user._id,
        {Estado__c:cEstado})
        .then(result=>{
          console.log(result);
          this.user=result.data;
          this.$swal({
            title: 'Se cambio el estado del usuario a '+cEstado,
            icon:'success',
            color:'#b4243a',
            confirmButtonText:'Aceptar',
            buttonsStyling:false,
            customClass:{
                confirmButton:'btn btn-danger'
            },
            confirmButtonColor:'#b4243a',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
          })
        });
      },

      sendCrendentials(){
        axios.get(this.$EndPoint+'users/mail-user/'+this.user._id)
        .then(result=>{
          console.log(result);
          this.$swal({
            title: 'Correo enviado',
            icon:'success',
            color:'#b4243a',
            confirmButtonText:'Aceptar',
            buttonsStyling:false,
            customClass:{
              confirmButton:'btn btn-danger'
            },
            confirmButtonColor:'#b4243a',
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          })
        });
      },
    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchUser();
      }else{
        this.$router.push('/signin')
      }
    }
  };
</script>